import React from 'react';
import {
  Flex,
  Text,
  SimpleGrid,
  Divider,
  Spacer,
  Textarea,
} from '@chakra-ui/react';
import styles from '../styles/mobileBannerStyles';
import theme from '../config/color';
import UncontrolledEditor from '../components/textEditor/textEditor';
import { useHistory } from 'react-router-dom';
import style from '../components/common/style';
import {
  customSwtich,
  customInputLabel,
  customUpdateCancelBtn,
} from '../components/createAppVersionComponent/createAppVersionComponent';
import { dropdownCustom } from '../components/bannerComponents/customBannerComponents';
import { renderCopyRight } from '../components/aboutUsComponent/customCompoent';
import {
  customTextarea,
  MiniHeader,
} from '../components/common/customComponent';
import { customSaveButton } from '../components/inboxMessagingComponent';

const CreatePhysicalRedemptionForm = () => {
  console.log('CreatePhysicalRedemptionForm gg bro');
  let history = useHistory();
  return (
    <Flex flexDirection={'column'} backgroundColor={'#FAFDFB'} height={'80vh'}>
       <Flex 
      {...style.miniheader}
      marginBottom={'2%'}
      >
      {MiniHeader({
        title: 'Create Physical Redemption Form',
        path: 'Dashboard',
        onclickForRoute: () => history.push('/Dashboard'),
        path1:'Physical Redemption Form',
        useSlash:true,
        path2:'Create Physical Redemption Form',
      })}
      </Flex>
     

      <Flex {...styles.parentFlex}>
        <SimpleGrid width={'100%'} columns={1} spacingX={'50px'}>
          {customInputLabel({
            title: 'Voucher ID',
            mandatory: true,
          })}
        </SimpleGrid>

        <SimpleGrid
          columns={1}
          marginTop={5}
          width={'100%'}
          spacingX={'50px'}
          spacingY={'20px'}
        >
          <Flex
            padding={5}
            borderWidth={1}
            flexDirection={'column'}
            height={'50vh'}
            width={'100%'}
          >
            <Text marginX={1} marginY={2} fontSize={'sm'}>
              Form Details *
            </Text>
            <UncontrolledEditor />
          </Flex>
        </SimpleGrid>
        <SimpleGrid width={'100%'} columns={1} spacingX={'50px'} marginTop={5}>
          {dropdownCustom({
            title: 'Status',
            mandatory: true,
          })}
        </SimpleGrid>
        
        {customUpdateCancelBtn({
          title1: 'Submit',
          title2: 'Cancel',
        })}
      </Flex>
      <Spacer />
      <Divider orientation="horizontal" marginTop={5} marginBottom={2} />
      <Flex position={'sticky'} marginLeft={4}>
        {renderCopyRight()}
      </Flex>
    </Flex>
  );
};

export default CreatePhysicalRedemptionForm;
